/* การ์ดเมนูแบบ tile ใช้ทั้งหน้ากลุ่มงานและหน้าเมนูย่อย
   ใช้ Link เพื่อให้ Ctrl/กลางคลิก เปิดแท็บใหม่ได้ */
import { Link } from "react-router-dom";
import { LockOutlined, PushpinFilled, PushpinOutlined } from "@ant-design/icons";

export default function Tile({
  icon,
  title,
  subtitle,
  badge,
  to,
  state,
  disabled = false,
  pinned,
  onTogglePin,
}) {
  /* ไม่มีสิทธิ์ใช้งาน — แสดงเป็นการ์ดสีเทา กดไม่ได้ */
  const Wrapper = disabled ? "div" : Link;
  const linkProps = disabled
    ? { title: "ไม่มีสิทธิ์เข้าใช้งานเมนูนี้" }
    : { to, state };

  return (
    <Wrapper
      {...linkProps}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        position: "relative",
        minHeight: 135,
        padding: "16px 12px",
        borderRadius: 14,
        color: disabled ? "#9aa5b4" : "#8a5a1c",
        background: disabled ? "#f2f4f7" : "#fbf6ec",
        border: `1px solid ${disabled ? "#e3e7ee" : "#efdfc2"}`,
        boxShadow: "0 2px 6px rgba(47,95,179,.06)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        textAlign: "center",
        textDecoration: "none",
        transition: "transform .15s ease, box-shadow .15s ease",
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.background = "#f5e8d0";
        e.currentTarget.style.boxShadow = "0 8px 18px rgba(47,95,179,.16)";
      }}
      onMouseLeave={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.background = "#fbf6ec";
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,95,179,.06)";
      }}
    >
      {typeof onTogglePin === "function" && !disabled ? (
        <span
          role="button"
          title={pinned ? "ถอนหมุด" : "ปักหมุดเมนูนี้"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onTogglePin();
          }}
          style={{
            position: "absolute",
            top: 8,
            left: 10,
            fontSize: 14,
            lineHeight: 1,
            padding: 4,
            borderRadius: 6,
            color: pinned ? "#f5a623" : "#b9c4d6",
          }}
        >
          {pinned ? <PushpinFilled /> : <PushpinOutlined />}
        </span>
      ) : null}

      {badge ? (
        <span
          style={{
            position: "absolute",
            top: 10,
            right: 14,
            fontSize: 13,
            fontWeight: 800,
            color: disabled ? "#b6bdc9" : "#c49a5a",
          }}
        >
          {badge}
        </span>
      ) : null}

      <div style={{ fontSize: 36, lineHeight: 1 }}>
        {disabled ? <LockOutlined /> : icon}
      </div>
      <div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.3 }}>{title}</div>
      {subtitle ? (
        <div style={{ fontSize: 11, color: disabled ? "#aab2bf" : "#9a7b55" }}>{subtitle}</div>
      ) : null}
    </Wrapper>
  );
}
